import React from 'react'
import { useState } from 'react';
import Pagination from 'react-js-pagination';
import moment from 'moment';
import Loader from '../../common/Loader';
import constant from '../../../constant';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toTitleCase } from '../../../utils';
import { AddStatusUpdate } from '../../../actions/utilitiesAction';
import queryString from 'query-string'

export default function InterviewQuestionList(props) {

    const [currentPage, setCurrentPage] = useState(1)
    const location = useLocation()
    const Navigate = useNavigate()

    const handlePageChange = (pageNumber) => {
        
        setCurrentPage(pageNumber);
        Navigate(location.pathname + '?p=' + pageNumber)
        props.setPage(pageNumber)
    };

    const updateStatus = (INTERVIEW_QUESTIONS_ID, STATUS) => {
        const model = {
            INTERVIEW_QUESTIONS_ID: INTERVIEW_QUESTIONS_ID,
            STATUS: STATUS == 'U' ? 'A' : 'U'
        }
        props.setPage(currentPage)
        props.updateStatus(model)
    }
    // const onInputClick = (data, status) => {
    //     const model = {
    //         INTERVIEW_QUESTIONS_ID: data,
    //         IQ_USER_TYPE: status
    //     }
    //     AddStatusUpdate(model).then((res) => {

    //     }).catch((err) => alert(err))
    // }

    const qParams = queryString.parse(location.search)
    const { cpage } = props
    return (
        <React.Fragment>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0" style={{ fontSize: "18px" }}>Interview Questions List</h4>

                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Utilities</a></li>
                                            <li className="breadcrumb-item active">Interview Questions List</li>
                                        </ol>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table align-middle table-wrap table-hover">
                                               
                                                {!props.showLoader && <thead className="table-light">
                                                    <tr>
                                                        <th scope="col">S.No.</th>
                                                        <th scope="col" style={{ width: "30%" }}>Interview Question</th>
                                                        <th scope="col" style={{ width: "25%" }}>Companies</th>
                                                        <th scope="col">Answers</th>
                                                        <th scope="col">Added On</th>
                                                        <th scope="col">Status</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>}
                                                <tbody>
                                                    { props.showLoader ?
                                                    <Loader /> : props.list && props.list.length > 0 &&
                                                        props.list.map((item, index, list) => {
                                                            return (
                                                                <tr>
                                                                    <td>{currentPage == 1 ? `${index + 1}` : `${index == 9 ? currentPage : currentPage - 1}` + `${index == 9 ? 0 : index + 1}`}</td>
                                                                    <td>
                                                                        <p className="text-primary mb-0" style={{ textTransform: "capitalize" }}>{item.QUESTION_TITLE}</p>
                                                                        <p className="text-muted mb-0"><strong>Skill: </strong>{toTitleCase(item.SKILL.toString().replace(/,/g, ', '))}</p>

                                                                        <p className="text-muted mb-0"><strong>ROLE: </strong>{toTitleCase(item.ROLES.toString().replace(/,/g, ', '))}</p>
                                                                    </td>
                                                                    <td>{item.COMPANIES}</td>
                                                                    {
                                                                        item.ANSWER_COUNT > 0 ? <td>
                                                                            <Link style={{ cursor: "pointer" }}
                                                                                to={{
                                                                                    pathname: constant.component.interviewAnswer.url.replace(':id', item.INTERVIEW_QUESTIONS_ID),
                                                                                    state: [{ INTERVIEW_QUESTIONS_ID: item.INTERVIEW_QUESTIONS_ID }]
                                                                                }}
                                                                            // to={constant.component.interviewAnswer.url}
                                                                            >Answers <span className="badge rounded-pill bg-danger">{item.ANSWER_COUNT}</span></Link> </td> : <td><a style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target="#staticBackdrop3" >Answers <span className="badge rounded-pill bg-danger">{item.ANSWER_COUNT}</span></a></td>
                                                                    }
                                                                    <td>
                                                                        {moment(item.MODIFIED_ON).format('DD.MM.YYYY on hh:mma')}
                                                                    </td>
                                                                    <td>
                                                                        {item.STATUS == 'U' ?
                                                                            <button type="button" className="btn btn-success"
                                                                                onClick={() => updateStatus(item.INTERVIEW_QUESTIONS_ID, item.STATUS)} data-toggle="button"
                                                                                aria-pressed="false" autocomplete="off">
                                                                                Approved
                                                                            </button>
                                                                            :
                                                                            <button type="button" className="btn btn-warning" onClick={() => {
                                                                                updateStatus(item.INTERVIEW_QUESTIONS_ID, item.STATUS)
                                                                            }} data-toggle="button" aria-pressed="false" autocomplete="off">
                                                                                Pending
                                                                            </button>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <ul className="list-inline contact-links mb-0" style={{ fontSize: "20px" }}>
                                                                            <li className="list-inline-item px-2">
                                                                                <Link to={constant.component.editInterviewQuestion.url.replace(':id', item.INTERVIEW_QUESTIONS_ID).replace(':pageno', cpage)
                                                                                } title="Edit User"><i className="bx bx-edit"></i></Link>
                                                                            </li>
                                                                            {/* <li className="list-inline-item px-2">
                                                                                <a href="javascript: void(0)" onClick={() => updateStatus(item.INTERVIEW_QUESTIONS_ID, item.STATUS)} style={{ color: 'red' }} title={item.STATUS == 'U' ? "Archive Record" : "Unarchive Record"}>
                                                                                    {
                                                                                        item.STATUS == 'U' ? <i className="bx bx-trash"></i> : <i class="bx bx-log-in"></i>
                                                                                    }
                                                                                </a>
                                                                            </li> */}
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    {
                                                        <>
                                                            {
                                                                props.list && props.list.length == 0 && props.showLoader == false &&
                                                                <td colSpan={10} className="text-center text-danger pt-3">No Interview Question Record Found</td>
                                                            }
                                                        </>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <ul className="pagination pagination-rounded justify-content-center mt-4">
                                                    <Pagination
                                                        activePage={qParams?.p ? +qParams?.p :
                                                            qParams?.pageno ? Number(qParams.pageno) : currentPage}
                                                        itemsCountPerPage={10}
                                                        totalItemsCount={props.count}
                                                        pageRangeDisplayed={5}
                                                        onChange={handlePageChange}
                                                        itemClass="page-item"
                                                        linkClass="page-link"
                                                    />
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
